<div class="container-fluid">
  <!-- Cabeçalho -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h2 class="mb-1">
            <i class="fas fa-calendar-alt me-2"></i>
            Feiras
          </h2>
          <p class="text-muted mb-0">Gerencie as feiras do sistema</p>
        </div>
        @if(!podeEditar){
          <button disabled type="text" title="Sem permissão" class="btn btn-light waves-effect">
            <i class="bx bx-block btn-sm font-size-16 align-middle me-2"></i>Adicionar
          </button>
        } @else {
          <button
            type="button"
            class="btn btn-primary"
            (click)="openEventModal()"
          >
            <i class="fas fa-plus me-2"></i>
            Adicionar Feira
          </button>
        }
      </div>
    </div>
  </div>

  @if (error || erro403) {
    @if(erro403){
      <app-no-access></app-no-access>
    } @else {
      <div class="alert alert-danger" role="alert">
        <i class="fas fa-exclamation-triangle me-2"></i>
        {{ error }}
      </div>
    }
  } @else {

  <!-- Lista -->
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="card-title mb-0">
        <i class="fas fa-list me-2"></i>
        Feiras
        @if (pagination.totalDeItens > 0) {
          ({{ pagination.totalDeItens }})
        }
      </h5>
    </div>
    <div class="card-body p-0">
      @if (isLoading) {
        <div class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Carregando...</span>
          </div>
          <p class="mt-2 text-muted">Carregando feiras...</p>
        </div>
      } @else {
        @if (events.length === 0) {
          <div class="text-center py-5">
            <i class="fas fa-calendar-alt fa-3x text-muted mb-3"></i>
            <h5 class="text-muted mb-0">Nenhuma feira encontrada</h5>
          </div>
        } @else {
          <div class="table-responsive">
            <form [formGroup]="filtroForm">
              <table class="table table-hover table-striped mb-0">
                <thead class="table-light">
                  <tr>
                    <th class="px-3 py-2">
                      <div class="col-5 d-flex flex-column">
                        <span class="fw-bold mb-2">Nome</span>
                        <input 
                          formControlName="nome" 
                          type="text" 
                          class="form-control form-control-sm" 
                          placeholder="Filtrar" 
                        />
                      </div>
                    </th>
                    <th class="px-3 py-2 text-center">
                      <span class="fw-bold">Ações</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (row of events; track $index) {
                    <tr>
                      <td class="px-3 py-2">{{ row.nome }}</td>
                      <td class="px-3 py-2 text-center">
                        <div class="dropdown" ngbDropdown>
                          @if(!podeEditar){
                            <i title="Sem permissão" class="bx bx-block font-size-16 align-middle"></i>
                          } @else {
                            <button 
                              class="btn btn-link font-size-16 shadow-none py-0 text-muted dropdown-toggle" 
                              type="button"
                              data-bs-toggle="dropdown" 
                              aria-expanded="false" 
                              ngbDropdownToggle
                            >
                              <i class="bx bx-dots-horizontal-rounded"></i>
                            </button>
                            <ul class="dropdown-menu" ngbDropdownMenu>
                              <li>
                                <button class="dropdown-item" (click)="openEventModal(row)">
                                  Visualizar
                                </button>
                              </li>
                              <li>
                                <button class="dropdown-item" (click)="onDeleteStatus(row)">
                                  Deletar
                                </button>
                              </li>
                            </ul>
                          }
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </form>
          </div>
        }
      }
    </div>

    <!-- Paginação e Botão Limpar Filtros -->
  </div>
  @if (!isLoading) {
    <div class="card-footer">
      <div class="row">
        <div class="col-sm-12 col-md-5">
          @if (pagination.totalDeItens > 0) {
            <div class="dataTables_info" role="status" aria-live="polite">
              Mostrando {{ (pagination.paginaAtual - 1) * pagination.quantidadePorPagina + 1 }} até
              {{ (pagination.paginaAtual * pagination.quantidadePorPagina) > pagination.totalDeItens ? 
                  pagination.totalDeItens : 
                  (pagination.paginaAtual * pagination.quantidadePorPagina) }} de
              {{ pagination.totalDeItens }} registros
            </div>
          } @else {
            <div class="dataTables_info" role="status" aria-live="polite">
              Nenhum registro encontrado
            </div>
          }
        </div>
        <div class="col-sm-12 col-md-7">
          @if (pagination.totalDeItens > 0) {
            <div class="dataTables_paginate paging_simple_numbers">
              <ngb-pagination
                [page]="pagination.paginaAtual"
                [pageSize]="pagination.quantidadePorPagina"
                [collectionSize]="pagination.totalDeItens"
                [maxSize]="5"
                [rotate]="true"
                [boundaryLinks]="true"
                (pageChange)="onPageChange($event)"
                class="pagination-rounded justify-content-end">
              </ngb-pagination>
            </div>
          }
        </div>
      </div>
      
    </div>
  }
  }
</div>
